import React, { useEffect, useState } from "react";
import { Select } from "../../../../../../components";


const SettingsSelect = ({
  id,
  label,
  options,
  initialValue = options[0],
  defaultValue,
  onChange,
}) => {
  const [value, setValue] = useState(null);

  const handleChange = ({ target }) => {
      setValue(target.value);
      onChange(id, target.value);
  };

  useEffect(() => {
      let value;

      const initialOption = options.find(({ value }) => `${value}` === `${initialValue}`);
      if (initialOption) {
          value = initialOption.value;
      } else {
          const defaultOption = options.find(({ value }) => `${value}` === `${defaultValue}`);
          if (defaultOption) {
              value = defaultOption.value;
          } else {
            value = options.length ? options[0].value : undefined;
          }
      }

      setValue(`${value}`);
  }, [initialValue]);


  return (
    <div className="mb-4">
      <div className="paylixecommerce-label">
        {label}
      </div>

        <Select
            size="large"
            value={value}
            onChange={handleChange}
            options={options.map(({ title, value }) => ({ label: title, value }))}
        />
    </div>
  );
};

export default SettingsSelect;
